module.exports = __webpack_public_path__ + "media/assets/certification_page/quote-close-d18d93485c1574c72b12bfb82e42dec095f4b6cef3c862c8f50670703737f94b.svg";